import React, { useEffect, useState } from "react";
import { useStateContext } from "../contexts/ContextProvider";
import ResultCard from "../components/ResultCard/ResultCard";
import { useParams } from "react-router-dom";
import Banner from "../components/Banner/Banner";
import Footer from "../components/Footer/Footer";
import Stats from "../components/LandingPageStats/Stats";
import Row from "../components/Row/Row";
import PopUpModal from "../components/PopUp/PopUpModal";

const Home = (props) => {
  const { id } = useParams();
  const {
    genres,
    channels,
    contests,
    loading,
    numberOfContests,
    getGenres,
    getAllContests,
    contestByGenres,
    getContestsGenres,
  } = useStateContext();
  let homeContests = contests;
  const [currentContest, setCurrentContest] = useState(null);
  const [showModal, setShowModal] = useState(false);

  if (id) {
    // Get contests by genre
    let contestByChannel = contests.filter((contest) => contest.genre === id);
    homeContests = contestByChannel;
  }

  useEffect(() => {
    // getContestsGenres();
    // getGenres();
    getAllContests();
    // setTimeout(() => {
    //   setShowModal(true);
    // }, 1000);
  }, []);

  if (loading || numberOfContests === -1)
    return <p className="text-center bg-blue-600 text-white">Loading...</p>;

  if (numberOfContests >= 0) {
    const songResult = homeContests.map((contest, index) => (
      <div
        onClick={(e) => {
          setCurrentContest(contest);
          if (!window.matchMedia("(max-width: 767px)").matches) {
            setShowModal(true);
          }
        }}
      >
        <ResultCard
          key={contest._id}
          url={`/contest/${contest._id}`}
          // url={`/song/1/${contest._id}`}
          artist=""
          title={contest.contestName ? `${contest.contestName}` : `Contest`}
          imgLink={
            contest.imgLink
              ? `${contest.imgLink}`
              : "https://source.unsplash.com/random/380×380/?concert"
          }
          buttonVisible={false}
        />
      </div>
    ));

    const contestMaintainence = (
      <div className="text-left text-white lg:px-44 p-6 lg:text-xl text-lg">
        <p className="text-center">
          We are LAUNCHING with 12 amazing CREATOR CONTEST CHANNELS
          <br />
          There are awesome prizes and it's free to enter your song into a
          contest!{" "}
        </p>
        <br />

        <div className="lg:text-lg text-md lg:mt-6 mt-0">
          <p>
            To submit into a contest, visit the link below and select the
            creator channel from the dropdown menu:{" "}
            <a
              className="text-blue-400"
              href="https://soundoffmusic.com/submission"
            >
              {" "}
              https://soundoffmusic.com/submission{" "}
            </a>
          </p>
          <br />
          <p>
            To get an advertisement on a contest channel,{" "}
            <a className="text-blue-300" href={`https://soundoffmusic.com/ads`}>
              visit this link{" "}
            </a>{" "}
            and select the creator channel from the dropdown menu.{" "}
          </p>
          <br />
          <p>
            To skip to the front of the line of a contest channel,{" "}
            <a
              className="text-blue-300"
              href={`https://soundoffmusic.com/skipline`}
            >
              visit this link{" "}
            </a>{" "}
            and select the creator channel from the dropdown menu.
          </p>
        </div>
      </div>
    );

    return (
      <>
        {showModal && (
          <PopUpModal data={currentContest} setShowModal={setShowModal} />
        )}
        {/* md:pl-44 pl-0   */}
        <div className="sm:mt-12 mt-8">
          {!id && <Banner />}
          <div className="flex text-center justify-center md:mt-6 mt-16 md:mb-12 mb-3">
            <p className="text-white w-2/3">
              WELCOME TO SOUNDOFF. CHECK OUT OUR MUSIC CONTESTS! EVERY CONTEST
              IS 8 ARTISTS, 3 ROUNDS, 72 HOURS EACH ROUND. ARTISTS ARE PAIRED UP
              IN EVERY ROUND AND VOTERS PICK THEIR FAVORITE ARTIST IN EACH PAIR.
              CLICK ON A CONTEST BELOW TO GET STARTED!
            </p>
          </div>
          {numberOfContests > 0 ? (
            <>
              {!id && <Stats />}
              {/* All genres with all contests */}
              {/* <div className="relative lg:pl-16 pl-6 pb-24 space-y-32 mb-20">
                {contestByGenres.length > 0 && contestByGenres.map(genre => (
                  genre.contests.length > 0 && <Row title={genre._doc.name} contests={genre.contests} />
                ))}

                // Matching genres with contests
                {genres.length > 0 &&
                  genres.map((genre) =>
                   <Row title={genre.name} contests={homeContests} />
                  )}
              </div> */}
              <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:grid-rows-2 gap-x-3 gap-y-6 sm:mt-0 mt-8">
                {songResult}
              </div>
            </>
          ) : (
            contestMaintainence
          )}
          <Footer />
        </div>
      </>
    );
  }
};

export default Home;
